import { USER_SEEN_STATE_SETTINGS_OBJECT_KEY, USER_LAST_PREVIEW_DEVICE, USER_BREAKPOINT_STYLING_TOOLTIP_DISMISSED, HAS_SEEN_SCOPES_HAVE_CHANGED_MODAL_KEY, IS_DISTRACTION_FREE_OPEN, ALL_USER_ATTRIBUTE_KEYS_IN_SUPERSTORE, ALL_LOCALLY_CACHED_PER_CONTENT_ATTRIBUTE_KEYS, HAS_SEEN_ONBOARDING_MODAL_LOCAL, HAS_CLICKED_ONBOARDING_MODAL_REMIND, HAS_SEEN_ANNOUNCEMENT_BANNER_OBJECT, HAS_SEEN_PATAGONIA_FEEDBACK_COUNT, HAS_RESPONDED_PATAGONIA_FEEDBACK, IS_FOCUS_MODE_ON, HAS_SEEN_BLOG_PLG_ONBOARDING_TOUR, HAS_SEEN_SECTIONS_LIBRARY_ONBOARDING_TOUR, HAS_OPENED_UNIVERSAL_THEME_EDITOR_PANEL
// @ts-ignore not typed yet
} from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
const getPerUserLocalSettings = state => state.locallyCachedSettings && state.locallyCachedSettings.get('perUser');
const getPerContentLocalSettings = state => state.locallyCachedSettings && state.locallyCachedSettings.get('perContent');
const maybeThrowMissingKeyWarning = (key, ALLOWED_KEYS) => {
  if (!ALLOWED_KEYS.includes(key)) {
    console.warn(`${key} is not a known attribute of ${ALLOWED_KEYS}.
      If you want it to persist, add to the appropriate array.`);
  }
};
export const makeGetUserLocalSetting = key => {
  maybeThrowMissingKeyWarning(key, ALL_USER_ATTRIBUTE_KEYS_IN_SUPERSTORE);
  return basicSelectorWithStats(state => {
    var _getPerUserLocalSetti;
    return getPerUserLocalSettings(state) && ((_getPerUserLocalSetti = getPerUserLocalSettings(state)) === null || _getPerUserLocalSetti === void 0 ? void 0 : _getPerUserLocalSetti.get(key));
  });
};
export const makeGetPerContentLocalSetting = key => {
  maybeThrowMissingKeyWarning(key, ALL_LOCALLY_CACHED_PER_CONTENT_ATTRIBUTE_KEYS);
  return basicSelectorWithStats(state => {
    var _getPerContentLocalSe;
    return getPerContentLocalSettings(state) && ((_getPerContentLocalSe = getPerContentLocalSettings(state)) === null || _getPerContentLocalSe === void 0 ? void 0 : _getPerContentLocalSe.get(key));
  });
};

// Selectors based on shared editor user attributes that are also locally cached in superstore
export const getUserSeenStateSettingsObject = makeGetUserLocalSetting(USER_SEEN_STATE_SETTINGS_OBJECT_KEY);
export const getUserLastPreviewDevice = makeGetUserLocalSetting(USER_LAST_PREVIEW_DEVICE);
export const getBreakpointStylingTooltipDismissed = makeGetUserLocalSetting(USER_BREAKPOINT_STYLING_TOOLTIP_DISMISSED);
export const getHasSeenScopesHaveChangedModal = makeGetPerContentLocalSetting(HAS_SEEN_SCOPES_HAVE_CHANGED_MODAL_KEY);
export const getHasSeenOnboardingModalFromSuperStore = makeGetUserLocalSetting(HAS_SEEN_ONBOARDING_MODAL_LOCAL);
export const getHasSeenBlogPlgOnboardingTourFromSuperStore = makeGetUserLocalSetting(HAS_SEEN_BLOG_PLG_ONBOARDING_TOUR);
export const getHasSeenPatagoniaFeedbackCountFromSuperStore = makeGetUserLocalSetting(HAS_SEEN_PATAGONIA_FEEDBACK_COUNT);
export const getHasRespondedPatagoniaFeedbackFromSuperStore = makeGetUserLocalSetting(HAS_RESPONDED_PATAGONIA_FEEDBACK);
export const getIsDistractionFreeOpen = makeGetPerContentLocalSetting(IS_DISTRACTION_FREE_OPEN);
export const getHasSeenSectionsLibraryOnboardingTourFromSuperStore = makeGetUserLocalSetting(HAS_SEEN_SECTIONS_LIBRARY_ONBOARDING_TOUR);
export const getIsFocusModeOn = makeGetUserLocalSetting(IS_FOCUS_MODE_ON);
export const getHasClickedOnboardingModalRemind = makeGetUserLocalSetting(HAS_CLICKED_ONBOARDING_MODAL_REMIND);
export const getHasOpenedUniversalThemeEditorPanel = makeGetUserLocalSetting(HAS_OPENED_UNIVERSAL_THEME_EDITOR_PANEL);
export const getShouldRemindOnboardingModal = (state, consumerName) => {
  const hasClickedOnboardingModalRemind = getHasClickedOnboardingModalRemind(state);
  if (!hasClickedOnboardingModalRemind || !hasClickedOnboardingModalRemind.get(consumerName)) {
    return false;
  }
  const nextWeekFromRemindClick = new Date(hasClickedOnboardingModalRemind.get(consumerName));
  nextWeekFromRemindClick.setDate(nextWeekFromRemindClick.getDate() + 7);
  return nextWeekFromRemindClick < new Date();
};
export const getShouldShowOnboardingModal = (state, consumerName) => {
  const seleniumIsRunning = window.SELENIUM_IS_RUNNING;
  const hasSeenOnboardingModalFromSuperStore = getHasSeenOnboardingModalFromSuperStore(state);
  const shouldRemindOnboardingModal = getShouldRemindOnboardingModal(state, consumerName);
  return !seleniumIsRunning && (!hasSeenOnboardingModalFromSuperStore || shouldRemindOnboardingModal);
};
export const getHasSeenAnnouncementBannerObject = makeGetUserLocalSetting(HAS_SEEN_ANNOUNCEMENT_BANNER_OBJECT);
export const getHasSeenAnnouncementBanner = (state, {
  bannerKey,
  consumerName
}) => {
  const hasSeenAnnouncementBannerObject = getHasSeenAnnouncementBannerObject(state);
  const hasSeenAnnouncementBanner = hasSeenAnnouncementBannerObject && hasSeenAnnouncementBannerObject.getIn([consumerName, bannerKey]);
  // Checking if we're dealing with an integer since instead of a timestamp we
  // used to set true to mark a banner as having been seen. We want a check
  // like this anyway since undefined is a possible value as well for locally
  // cached setting selectors.
  return Number.isInteger(hasSeenAnnouncementBanner) ? hasSeenAnnouncementBanner : false;
};